function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { jsx, jsxs } from 'react/jsx-runtime';
import React, { memo, useEffect } from 'react';
import classnames from 'classnames';
import { Image } from 'nordic/image';
const namespace$7 = "ui-cpg-icon ui-cpg-icon--chevron";
const IconChevronDesktop = _ref => {
  let {
    className = ""
  } = _ref;
  return jsx("svg", {
    className: classnames(namespace$7, className),
    viewBox: "0 0 9 14",
    xmlns: "http://www.w3.org/2000/svg",
    children: jsx("path", {
      fill: "none",
      fillRule: "evenodd",
      strokeWidth: "1.5",
      d: "M1 1.343L6.657 7 1 12.657"
    })
  });
};
var IconChevronDesktop$1 = /*#__PURE__*/memo(IconChevronDesktop);
const Department = _ref2 => {
  let {
    name,
    id,
    color,
    permalink,
    main_image,
    subdepartments,
    namespace,
    isSelected,
    subdepartments_to_display,
    ga_info,
    action,
    totalDepartments
  } = _ref2;
  const [isOpen, setIsOpen] = React.useState(false);
  const departmentRef = React.useRef(null);
  namespace = `${namespace}__department`;
  const isALargeCarousel = totalDepartments > 7;
  const openSubmenu = () => {
    setIsOpen(true);
  };
  const closeSubmenu = e => {
    e.preventDefault();
    setIsOpen(false);
  };
  const handleClick = event_track => {
    // @ts-ignore
    if (window.meli_ga) {
      // @ts-ignore
      window.meli_ga('send', event_track.type, event_track.category, event_track.action);
    }
  };
  const handleKeyDown = event => {
    const currentTarget = event.currentTarget;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (subdepartments.length > 0) {
        setIsOpen(prevState => !prevState);
      } else {
        window.location.href = permalink;
      }
    } else if (event.key === 'Escape' || event.key === 'Escape' && currentTarget.contains(document.activeElement)) {
      var _document$getElementB;
      event.preventDefault();
      closeSubmenu(event);
      (_document$getElementB = document.getElementById(id)) === null || _document$getElementB === void 0 || _document$getElementB.focus();
    }
  };
  const handleBlur = event => {
    const currentTarget = event.currentTarget;
    requestAnimationFrame(() => {
      if (!currentTarget.contains(document.activeElement)) {
        closeSubmenu(event);
      }
    });
  };
  return jsxs("div", {
    className: namespace,
    style: isSelected || isOpen ? {
      backgroundColor: color
    } : {},
    ref: departmentRef,
    onMouseLeave: closeSubmenu,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    children: [jsxs("a", _objectSpread(_objectSpread({
      id: id,
      className: classnames(`${namespace}-link`, {
        [`${namespace}-link--large-carousel`]: isALargeCarousel
      }),
      href: permalink,
      "aria-label": name
    }, subdepartments.length > 0 && {
      'aria-expanded': isOpen
    }), {}, {
      onClick: () => {
        handleClick(ga_info.event_track);
      },
      onMouseEnter: openSubmenu,
      children: [jsx(Image, {
        src: main_image.desktop.x1,
        srcSet: main_image.desktop.x2,
        alt: name,
        className: classnames(`${namespace}-link-image`, {
          [`${namespace}-link-image--large-carousel`]: isALargeCarousel
        }),
        lazyload: "off",
        preload: true
      }), jsx("span", {
        className: classnames(`${namespace}-link-name`, {
          [`${namespace}-link-name--white`]: isSelected || isOpen,
          [`${namespace}-link-name--large-carousel`]: isALargeCarousel
        }),
        children: name
      })]
    })), subdepartments.length > 0 && jsxs("div", {
      className: `${namespace}-menu`,
      "aria-hidden": !isOpen,
      children: [jsx("h4", {
        className: `${namespace}-menu-title`,
        style: {
          color
        },
        children: name
      }), jsx("ul", {
        className: `${namespace}-menu-list`,
        children: subdepartments.slice(0, subdepartments_to_display).map(_ref3 => {
          let {
            id,
            name,
            permalink: subPermalink,
            ga_info
          } = _ref3;
          return jsx("li", {
            className: `${namespace}-menu-list-item`,
            children: jsx("a", {
              href: subPermalink,
              className: `${namespace}-menu-list-item-link`,
              onClick: () => {
                handleClick(ga_info.event_track);
              },
              children: name
            })
          }, id);
        })
      }), jsxs("a", {
        href: action.target,
        className: `${namespace}-menu-link`,
        onClick: () => {
          handleClick(ga_info.show_all.event_track);
        },
        children: [action.label.text, jsx(IconChevronDesktop$1, {
          className: `${namespace}-menu-chevron ui-cpg-color--blue ui-cpg-icon`
        })]
      })]
    })]
  });
};
const namespace$6 = "ui-cpg-icon ui-cpg-icon--fast-truck";
const IconFastTruck = _ref4 => {
  let {
    className = ""
  } = _ref4;
  return jsx("svg", {
    className: classnames(namespace$6, className),
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    children: jsx("path", {
      fillRule: "nonzero",
      d: "M10.587 14.805H7.01a2.452 2.452 0 1 1-4.452-1.937l-1.56-.003.002-1.2 3.6.008v.025h.048c1.167 0 2.143.815 2.39 1.907h3.52a2.455 2.455 0 0 1 1.836-1.844l2.423-6.352a.6.6 0 0 0-.56-.814H4.6v-1.2h9.658a1.8 1.8 0 0 1 1.697 2.4h1.677l1.409 4.225-2.027 4.787-1.701-.007a2.452 2.452 0 0 1-4.726.005zm4.751-1.205l.883.004 1.538-3.634-.991-2.975h-1.27l-1.835 4.809c.834.253 1.48.939 1.675 1.796zM7 5.79v1.2H1v-1.2h6zM4.6 8.222v1.2H2.2v-1.2h2.4zm.049 7.178a1.251 1.251 0 1 0 0-2.502 1.251 1.251 0 0 0 0 2.502zm8.3 0a1.251 1.251 0 1 0 0-2.502 1.251 1.251 0 0 0 0 2.502z"
    })
  });
};
var IconFastTruck$1 = /*#__PURE__*/React.memo(IconFastTruck);
const namespace$5 = "ui-cpg";
const textWithTruck = props => jsxs("div", {
  className: `${namespace$5}__default-section-shipping`,
  children: [jsx(IconFastTruck$1, {
    className: `${namespace$5}__default-section-shipping-icon ${namespace$5}-color--${props.color}`
  }), jsx("span", {
    className: `${namespace$5}__default-section-shipping-text ${namespace$5}-color--${props.color.toLowerCase}`,
    children: props.text
  })]
});
const namespace$4 = "ui-cpg-icon--full";
const iconFull = _ref5 => {
  let {
    className = ""
  } = _ref5;
  return jsx("svg", {
    className: classnames(namespace$4, className),
    width: "41",
    height: "13",
    viewBox: "0 0 41 13",
    xmlns: "http://www.w3.org/2000/svg",
    children: jsx("path", {
      fillRule: "nonzero",
      d: "M2.628 0h5.255L5.255 4.643h4.38L2.628 13l1.751-5.571H0L2.628 0zm11.589 9.533h-1.959l1.674-7.515H19.5l-.376 1.69h-3.61l-.25 1.172h3.519l-.376 1.69h-3.53l-.66 2.963zm9.468.136c-2.334 0-3.484-1.105-3.484-2.682 0-.124.034-.383.057-.496l1.002-4.473h1.992l-.99 4.428c-.012.057-.034.18-.034.316.011.62.49 1.217 1.457 1.217 1.048 0 1.583-.654 1.776-1.533l.991-4.428h1.981l-.99 4.462c-.41 1.825-1.412 3.189-3.758 3.189zm10.118-.136h-5.01l1.673-7.515h1.959l-1.287 5.825h3.04l-.375 1.69zm6.678 0h-5.01l1.674-7.515h1.959l-1.287 5.825h3.04l-.376 1.69z"
    })
  });
};
var IconFull = /*#__PURE__*/React.memo(iconFull);
const namespace$3 = "ui-cpg-icon--supermarket";
const iconSupermarket = _ref6 => {
  let {
    className = ""
  } = _ref6;
  return jsx("svg", {
    className: classnames(namespace$3, className),
    width: "164",
    height: "14",
    viewBox: "0 0 165 15",
    xmlns: "http://www.w3.org/2000/svg",
    children: jsx("path", {
      fillRule: "nonzero",
      d: "M6.04 57.24c3.3 0 5.26-2.14 5.26-4.58 0-3.86-6.52-3.64-6.52-5.38 0-.72.76-1.32 1.78-1.32 1.36 0 2.98.54 3.98 1.7l1.78-2.04c-1.2-1.38-3.2-2.16-5.32-2.16-3.28 0-5.22 2.14-5.22 4.34 0 3.9 6.5 3.54 6.5 5.42 0 .68-.58 1.5-2.02 1.5-1.84 0-3.58-.84-4.5-2.08L0 54.74c1.12 1.48 3.42 2.5 6.04 2.5zm13.3 0c3.94 0 5.62-2.34 6.32-5.58l1.78-8h-2.9L22.8 51.6c-.42 1.86-1.42 3.14-3.46 3.14-1.88 0-2.86-1.14-2.88-2.48 0-.28.04-.54.08-.66l1.74-7.94H15.4l-1.76 8c-.04.22-.1.66-.1.92 0 2.78 1.98 4.66 5.8 4.66zM30.18 57l1.06-4.76h3.34c4.18 0 5.52-2.9 5.52-4.88 0-2.02-1.58-3.7-3.72-3.7h-6.1L27.34 57h2.84zm4.58-7.26h-2.98l.8-3.58h2.9c.98 0 1.66.62 1.66 1.5 0 1.18-.96 2.08-2.38 2.08zM49.48 57l.54-2.5h-6.58l.66-3.04h6.46l.54-2.5h-6.44l.62-2.8h6.58l.56-2.5h-9.44L40.04 57h9.44zm5.26 0l1.04-4.74h2.2L59.56 57h3.16l-1.86-4.94c2.16-.4 3.8-2.24 3.8-4.64 0-2.32-1.96-3.76-4.12-3.76h-5.7L51.9 57h2.84zm4.58-7.24h-2.98l.8-3.6H60c.88 0 1.7.64 1.7 1.54 0 1.2-.9 2.06-2.38 2.06zM67.8 57l2.12-9.62L71.56 57h1.24l5.88-9.62L76.56 57h2.86l2.94-13.34h-4.1L73.18 52l-1.4-8.34H67.9L64.96 57h2.84zm23.9 0l.54-2.5h-6.58l.66-3.04h6.46l.54-2.5h-6.44l.62-2.8h6.58l.56-2.5H85.2L82.26 57h9.44zm5.26 0L98 52.26h2.2l1.58 4.74h3.16l-1.86-4.94c2.16-.4 3.8-2.24 3.8-4.64 0-2.32-1.96-3.76-4.12-3.76h-5.7L94.12 57h2.84zm4.58-7.24h-2.98l.8-3.6h2.86c.88 0 1.7.64 1.7 1.54 0 1.2-.9 2.06-2.38 2.06zm12.84 7.48c1.74 0 3.96-.62 5.5-2.58l-2.2-1.48c-.76.94-2 1.54-3.14 1.54-2.3 0-3.74-1.56-3.74-3.64 0-2.94 2.12-5.12 4.64-5.12 1.54 0 2.82.76 3.34 2.18l2.72-.92c-.78-2.02-2.66-3.78-5.92-3.78-4.14 0-7.76 3.1-7.76 7.82 0 3.64 2.88 5.98 6.56 5.98zm8.58-.24l1.32-2.26H130l.34 2.26h3.08l-2.2-13.34h-3.56L119.58 57h3.38zm6.82-4.76h-4.16l3.34-5.74.82 5.74zM140.1 57c6.28 0 8.64-4.1 8.64-7.62 0-3.44-2.82-5.72-5.78-5.72h-5.16L134.86 57h5.24zm.52-2.5h-2.36l1.84-8.34h2.34c1.96 0 3.36 1.48 3.36 3.42 0 2.66-1.96 4.92-5.18 4.92zm16 2.74c4.4 0 7.76-3.48 7.76-7.84 0-3.66-2.88-5.96-6.56-5.96-4.4 0-7.76 3.46-7.76 7.82 0 3.66 2.86 5.98 6.56 5.98zm.16-2.52c-2.14 0-3.74-1.4-3.74-3.64 0-2.86 2.02-5.12 4.6-5.12 2.14 0 3.76 1.4 3.76 3.64 0 2.86-2.04 5.12-4.62 5.12z",
      transform: "translate(-131 -144) translate(130.98 101)"
    })
  });
};
var IconSupermarket = /*#__PURE__*/React.memo(iconSupermarket);
const namespace$2 = "ui-cpg__default-section";
const freeShipping = "-free-shipping";
const index = props => {
  const textsBeforeAndAfterIcon = props.text.split("{0}");
  const textBeforeIcon = textsBeforeAndAfterIcon.length > 0 ? textsBeforeAndAfterIcon[0] : null;
  const textAfterIcon = textsBeforeAndAfterIcon.length > 1 ? textsBeforeAndAfterIcon[1] : null;
  const isSupermarketIcon = iconId => {
    if (iconId === "supermarket") {
      return jsx(IconSupermarket, {
        className: `${namespace$2}${freeShipping}-supermarket`
      });
    } else {
      return jsx(IconFull, {
        className: `${namespace$2}${freeShipping}-icon`
      });
    }
  };
  return jsx("div", {
    className: `${namespace$2}-text`,
    children: jsxs("p", {
      children: [textBeforeIcon, isSupermarketIcon(props.iconId), textAfterIcon]
    })
  });
};
const namespace$1 = "ui-cpg__default-section";
const DiscountText = _ref7 => {
  let {
    text
  } = _ref7;
  return jsx("div", {
    className: `${namespace$1}-text`,
    children: jsx("p", {
      children: text
    })
  });
};
const namespace = "ui-cpg";
const CPG = _ref8 => {
  let {
    default_section,
    departments,
    selected_department_id,
    subdepartments_to_display,
    runCatchErrorBoundary = error => {
      throw error;
    }
  } = _ref8;
  try {
    const {
      icon,
      free_shipping
    } = default_section;
    const discountText = default_section.text;
    useEffect(() => {
      // @ts-ignore
      if (window.melidata) {
        // @ts-ignore
        window.melidata("cleanAndSend", "view", {
          path: "/supermarket/header",
          data: {
            departments: ["MLB2407", "MLB1246", "MLB264051", "MLB1384", "MLB1071", "MLB278123", "MLB1423"],
            client_id: "search",
            selected_department: "search"
          }
        });
      }
    }, [default_section]);
    const getFreeShippingContent = () => free_shipping ? jsx(index, {
      text: free_shipping.text,
      iconId: icon.id
    }) : jsx(textWithTruck, {
      text: icon.text,
      color: icon.color
    });
    const getDefaultSectionContent = () => discountText ? jsx(DiscountText, {
      text: discountText
    }) : getFreeShippingContent();
    return jsx("div", {
      className: namespace,
      children: jsx("div", {
        className: `${namespace}--reset`,
        children: jsxs("div", {
          className: `${namespace}__container`,
          children: [jsxs("a", {
            href: default_section.permalink,
            className: `${namespace}__default-section`,
            style: {
              color: default_section.color
            },
            children: [icon.id === "supermarket" ? jsx(IconSupermarket, {
              className: "ui-cpg__default-section-supermarket-icon"
            }) : default_section.name, getDefaultSectionContent()]
          }), departments.map(department => jsx(Department, _objectSpread(_objectSpread({}, department), {}, {
            subdepartments_to_display: subdepartments_to_display,
            namespace: namespace,
            isSelected: selected_department_id === department.id,
            totalDepartments: departments.length
          }), department.id))]
        })
      })
    });
  } catch (error) {
    return runCatchErrorBoundary(error);
  }
};
export { CPG as default };
//# sourceMappingURL=desktop.js.map
